import InputSelectForm from "@common/input/InputSelectForm";
import ChannelSelect from "@components/channel/components/ChannelSelect";
import Drawer from "@components/shared/Drawer";
import UserSelect from "@components/user/components/UserSelect";
import WarehouseSelect from "@components/warehouse/components/WarehouseSelect";
import { ORDER_STATUS_ARRAY } from "@constants/order";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";

function DiscountCodeUsageFilterDrawer({
  open,
  onClose,
  defaultValue,
  onFilter,
}: any) {
  const { t } = useTranslation();

  const filterForm = useFormik({
    initialValues: defaultValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      onFilter && onFilter(values);
      onClose();
    },
  });
  const formValues = filterForm?.values ?? {};
  const formErrors = filterForm?.errors;

  const classNameField = "col-span-12";

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={t("filter")}
      onSave={() => filterForm.handleSubmit()}
      size="large"
    >
      <div className="grid grid-cols-4 gap-4">
        <ChannelSelect
          className={classNameField}
          value={formValues?.channels}
          onChange={(value) => filterForm.setFieldValue("channels", value)}
          multiple
        />
        <UserSelect
          label={t("usedBy")}
          className={classNameField}
          value={formValues?.staff}
          onChange={(value) => filterForm.setFieldValue("staff", value)}
          multiple
        />
        <WarehouseSelect
          className={classNameField}
          value={formValues?.stores}
          onChange={(value) => filterForm.setFieldValue("stores", value)}
          multiple
        />
        <InputSelectForm
          className={classNameField}
          label={t("status")}
          dataSource={ORDER_STATUS_ARRAY}
          keyData="status"
          form={filterForm}
          multiple
        />
      </div>
    </Drawer>
  );
}

export default DiscountCodeUsageFilterDrawer;
